// extracted by mini-css-extract-plugin
export default {"spacer":"spacer___v2_Ie","hidden":"hidden___bW_5M"};